import { createFetchRequester } from '@algolia/requester-fetch'

import type { AlgoliaDomain } from '../../types'
import { useAlgoliaHost } from '../useAlgoliaHost/useAlgoliaHost'

export type { AlgoliaDomain }

type AlgoliaSearchOptions = {
  hosts: { url: string; protocol: string }[]
  headers: Record<string, string>
  requester: ReturnType<typeof createFetchRequester>
}

export function useAlgoliaSearchOptions(
  domain: AlgoliaDomain,
): AlgoliaSearchOptions {
  const host = useAlgoliaHost()

  const serverOnlyHeaders: Record<string, string> = import.meta.server
    ? {
        'user-agent': 'bm-search-javascript-client',
      }
    : {}

  return {
    hosts: [{ url: host.url.value, protocol: host.protocol }],
    headers: {
      'BM-Search-Domain': domain,
      ...serverOnlyHeaders,
    },
    requester: createFetchRequester({
      requesterOptions: { credentials: 'include' },
    }),
  }
}
